import {
  BRAND_IMG101,
  BRAND_IMG102,
  BRAND_IMG103,
  BRAND_IMG104,
  BRAND_IMG105,

  BRAND_IMG61,
  BRAND_IMG62,
  BRAND_IMG63,
  BRAND_IMG64,
  BRAND_IMG65,
  BRAND_IMG66,
  BRAND_IMG67,
  BRAND_IMG68,
  BRAND_IMG69,
  BRAND_IMG70,

  BRAND_IMG71,
  BRAND_IMG72,
  BRAND_IMG73,
  BRAND_IMG74,
  BRAND_IMG75,
  BRAND_IMG76,
  BRAND_IMG77,
  BRAND_IMG78,
  BRAND_IMG79,
  BRAND_IMG80,

  BRAND_IMG81,
  BRAND_IMG82,
  BRAND_IMG83,
  BRAND_IMG84,
  BRAND_IMG85,
  BRAND_IMG86,
  BRAND_IMG87,
  BRAND_IMG88,
  BRAND_IMG89,
  BRAND_IMG90,

  BRAND_IMG91,
  BRAND_IMG92,
  BRAND_IMG93,
  BRAND_IMG94,
  BRAND_IMG95,
  BRAND_IMG96,
  BRAND_IMG97,
  BRAND_IMG98,
  BRAND_IMG99,
  BRAND_IMG100,

} from "../lib/assets";

export const BRAND_LIST_HOME = [
  { id: 1, src: BRAND_IMG61 },
  { id: 2, src: BRAND_IMG62 },
  { id: 3, src: BRAND_IMG63 },
  { id: 4, src: BRAND_IMG64 },
  { id: 5, src: BRAND_IMG65 },
  { id: 6, src: BRAND_IMG66 },
  { id: 7, src: BRAND_IMG67 },
  { id: 8, src: BRAND_IMG68 },
  { id: 9, src: BRAND_IMG69 },
  { id: 10, src: BRAND_IMG70 },

  { id: 11, src: BRAND_IMG71 },
  { id: 12, src: BRAND_IMG72 },
  { id: 13, src: BRAND_IMG73 },
  { id: 14, src: BRAND_IMG74 },
  { id: 15, src: BRAND_IMG75 },
  { id: 16, src: BRAND_IMG76 },
  { id: 17, src: BRAND_IMG77 },
  { id: 18, src: BRAND_IMG78 },
  { id: 19, src: BRAND_IMG79 },
  { id: 20, src: BRAND_IMG80 },

  { id: 21, src: BRAND_IMG81 },
  { id: 22, src: BRAND_IMG82 },
  { id: 23, src: BRAND_IMG83 },
  { id: 24, src: BRAND_IMG84 },
  { id: 25, src: BRAND_IMG85 },
  { id: 26, src: BRAND_IMG86 },
  { id: 27, src: BRAND_IMG87 },
  { id: 28, src: BRAND_IMG88 },
  { id: 29, src: BRAND_IMG89 },
  { id: 30, src: BRAND_IMG90 },

  { id: 31, src: BRAND_IMG91 },
  { id: 32, src: BRAND_IMG92 },
  { id: 33, src: BRAND_IMG93 },
  { id: 34, src: BRAND_IMG94 },
  { id: 35, src: BRAND_IMG95 },
  { id: 36, src: BRAND_IMG96 },
  { id: 37, src: BRAND_IMG97 },
  { id: 38, src: BRAND_IMG98 },
  { id: 39, src: BRAND_IMG99 },
  { id: 40, src: BRAND_IMG100 },

  { id: 41, src: BRAND_IMG101 },
  { id: 42, src: BRAND_IMG102 },
  { id: 43, src: BRAND_IMG103 },
  { id: 44, src: BRAND_IMG104 },
  { id: 45, src: BRAND_IMG105 },
];
